export const LANDING_LAPTOP_BAND = "@media (min-width: 1200px) and (max-width: 1499px)";

export const LANDING_SHARED_LAYOUT = {
  heroDesktopMinHeight: 735,
  heroDesktopMaxWidth: 1400,
  heroLaptopMaxWidth: 1240,
  heroCopyLaptopMaxWidth: 540,
  sectionLaptopMaxWidth: 1120,
  sectionLaptopPaddingX: "3%",
  heroLaptopPadding: "64px 3.25% 60px",
};

export const LANDING_SHARED_TYPOGRAPHY = {
  heroTitleDesktop: "clamp(2rem, 4vw, 3.2rem)",
  heroTitleLaptop: "clamp(1.56rem, 2.55vw, 2.22rem)",
  heroTitleTablet: "clamp(1.75rem, 3.4vw, 2.6rem)",
  heroTitleMobile: "clamp(1.5rem, 8vw, 1.9rem)",
  heroBodyDesktop: "clamp(1rem, 1.5vw, 1.15rem)",
  heroBodyLaptop: "clamp(0.88rem, 1vw, 0.98rem)",
  heroBodyTablet: "clamp(0.95rem, 1.15vw, 1rem)",
  heroBodyMobile: "clamp(0.9rem, 3.6vw, 0.95rem)",
  sectionTitleDesktop: "clamp(1.6rem, 3vw, 2.3rem)",
  sectionTitleLaptop: "clamp(1.38rem, 1.95vw, 1.76rem)",
  sectionTitleTablet: "clamp(1.3rem, 2.35vw, 1.8rem)",
  sectionTitleMobile: "clamp(1.22rem, 5.5vw, 1.58rem)",
  sectionBodyDesktop: "clamp(1rem, 1.3vw, 1.05rem)",
  sectionBodyLaptop: "clamp(0.86rem, 0.95vw, 0.92rem)",
  sectionBodyTablet: "clamp(0.92rem, 1vw, 0.98rem)",
  sectionBodyMobile: "clamp(0.84rem, 3.8vw, 0.9rem)",
  smallTextDesktop: "clamp(0.78rem, 0.9vw, 0.84rem)",
  smallTextLaptop: "clamp(0.76rem, 0.85vw, 0.8rem)",
  smallTextTablet: "clamp(0.74rem, 0.8vw, 0.78rem)",
  smallTextMobile: "clamp(0.72rem, 3vw, 0.78rem)",
  statValueDesktop: "clamp(1.58rem, 2vw, 1.45rem)",
  statValueLaptop: "clamp(1.28rem, 1.7vw, 1.45rem)",
  statValueTablet: "clamp(1.2rem, 1.5vw, 1.35rem)",
  statValueMobile: "clamp(1.1rem, 4vw, 1.2rem)",
  statLabelDesktop: "0.9rem",
  statLabelLaptop: "0.76rem",
  statLabelTablet: "0.76rem",
  statLabelMobile: "0.76rem",
};

export const LANDING_SHARED_BUTTONS = {
  desktopGap: 14,
  laptopGap: 8,
  desktopPadding: "10px 18px",
  laptopPadding: "9px 14px",
  desktopFontSize: "clamp(0.85rem, 0.95vw, 0.95rem)",
  laptopFontSize: "clamp(0.8rem, 0.9vw, 0.88rem)",
  tabletFontSize: "clamp(0.8rem, 0.9vw, 0.88rem)",
  mobileFontSize: "clamp(0.78rem, 3vw, 0.82rem)",
  radius: 16,
};

export const LANDING_SHARED_FONTS = {
  body: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  heading: "'DM Serif Display', serif",
};
